module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kanban"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "contenteditable": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "settings-btn --header",
    on: {
      "click": function($event) {
        return _vm.addColumn()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns",
    class: _vm.columns_cls
  }, _vm._l((_vm.tasklists), function(tasklist, tasklist_i) {
    return _c('div', {
      staticClass: "column"
    }, [(_vm.tasklists.length > 1) ? _c('div', {
      staticClass: "column-header"
    }, [_c('div', {
      staticClass: "column-title",
      attrs: {
        "contenteditable": ""
      }
    }, [_vm._v(_vm._s(tasklist.title))]), _vm._v(" "), _c('div', {
      staticClass: "settings-btn --column",
      on: {
        "click": function($event) {
          return _vm.removeColumn(tasklist_i)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cards"
    }, [_vm._l((_vm.tasks), function(task, task_i) {
      return (task.col_index == tasklist_i) ? _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "card-title",
        attrs: {
          "contenteditable": ""
        }
      }, [_vm._v("Task title")]), _vm._v(" "), _c('div', {
        staticClass: "card-excerpt",
        attrs: {
          "contenteditable": ""
        }
      }, [_vm._v(_vm._s(task.text))]), _vm._v(" "), _c('div', {
        staticClass: "settings-btn --card",
        on: {
          "click": function($event) {
            return _vm.removeTask(task_i)
          }
        }
      })]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "new-card-btn",
      on: {
        "click": function($event) {
          return _vm.addTask(tasklist_i)
        }
      }
    }, [_vm._v("Add")])], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02434062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kanban.vue
// module id = 577
// module chunks = 1